module.exports = __webpack_public_path__ + "static/media/guandao.0424ed48.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/guandao.png
 ** module id = 436
 ** module chunks = 0
 **/